export { default } from "./DetailAccordion";
export * from "./DetailAccordion";
